// packages/shared/src/villagers/nav.ts — the frozen schedule NavGrid (D-40, contracts §7.5)
import { buildNavGrid } from '../map/nav';
import type { Rect } from '../types/geom';
import type { GeneratedTown, NavGrid } from '../types/map';

/** D-40: the only NavGrid villager schedules use. Generator map + objects, with every plot's house rect and the shop and
 *  museum sites blocked (the plaza stays open). Frozen per town: saplings, yard items and new houses never change it. */
export function scheduleNav(gen: GeneratedTown): NavGrid {
  const grid = buildNavGrid(gen.map, gen.objects);
  const walk = grid.walk.slice();
  const block = (r: Rect) => {
    for (let y = r.y; y < r.y + r.h; y++) for (let x = r.x; x < r.x + r.w; x++) {
      if (x >= 0 && y >= 0 && x < grid.w && y < grid.h) walk[y * grid.w + x] = 0;
    }
  };
  for (const p of gen.map.plots) block(p.house);
  block(gen.map.sites.shop);
  block(gen.map.sites.museum);
  return { ...grid, walk };
}
